document.addEventListener('DOMContentLoaded', () => {

  const menus = [
      {
          parent: '.c-header-desktop .c-secondary-menu > ul > li > a',
          currentLanguage: '.c-header-desktop .c-secondary-menu .mlp-current-language-item'
      },
      {
          parent: '.c-mobile-menu_language > .menu-item > .nav-link',
          currentLanguage: '.c-mobile-menu_language .mlp-current-language-item'
      }
  ];

  menus.forEach((menu) => {

      const parentEl = document.querySelector(menu.parent);
      const currentEl = document.querySelector(menu.currentLanguage);

      if (!parentEl || !currentEl) {
          return;
      }

      parentEl.innerHTML = currentEl.textContent;

      const classesStartingWithFlag = Array.from(currentEl.classList).filter(className => className.startsWith('c-flags'));
      if (classesStartingWithFlag.length >= 2) {
          parentEl.parentElement.classList.add(classesStartingWithFlag[0], classesStartingWithFlag[1]);
      }

  });

});



// WEBPACK FOOTER //
// ./src/scripts/modules/languageSwither.js